import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell } from "@/components/dashboard-shell";
import { PartnerNewForm } from "@/components/partner-new-form";
import { Route as RootRoute } from "./__root";

export const Route = createFileRoute("/partners/new")({
  component: PartnerNewPage,
});

function PartnerNewPage() {
  const { user } = RootRoute.useRouteContext();
  return (
    <DashboardShell userLabel={user?.displayName || user?.loginName || ""}>
      <PartnerNewForm />
    </DashboardShell>
  );
}
